import {
    Alert,
    Dialog,
    DialogActions,
    DialogContent,
    DialogProps,
    DialogTitle,
    Stack,
} from "@mui/material";
import React, {useEffect, useState} from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import {useMutation} from "react-query";
import {LoadingButton} from "@mui/lab";
import {MaileonTransactionType} from "crqlar-react-common/dist/models/marketing/maileonTransactionType.model";
import {
    MailingConfigControllerService
} from "crqlar-react-common/dist/services/correspondence/mailingConfigController.service";
import {MaileonSnackbar} from "../../../utils/alert/MaileonSnackbar";
import {useLocalize} from "crqlar-react-common/dist/utils/text.util";

interface Props extends DialogProps {
    onAdded: (transactionType: MaileonTransactionType) => void
    onClose: () => void
}

const QuickAddTransactionTypeDialog = (props: Props) => {

    const {t} = useLocalize()
    const [transactionType, setTransactionType] = React.useState<MaileonTransactionType>()
    const NAME_PATTERN = /^[a-zA-Z0-9_]+$/;
    const nameValid = NAME_PATTERN.test(transactionType?.name || '')

    const [snackbar, setSnackbar] = useState<{
        open: boolean;
        message: string;
        severity: "success" | "error" | "info" | "warning";
    }>({
        open: false, message: "", severity: "info"
    })

    useEffect(() => {
        if (props.open) {
            setTransactionType({
                name: ''
            })
        }
    }, [props.open])

    const createTransactionTypeMut = useMutation(
        'createTransactionType',
        async () => {
            if (!transactionType) return
            let response = await MailingConfigControllerService.create(transactionType)

            setSnackbar({
                open: true,
                message: response.message || t('Transaction type created successfully'),
                severity: response.severity
            })

            if(response.severity === 'success') {
                props.onAdded(response.data as MaileonTransactionType)
            }
        }
    )

    return (
        <>
            {/*Using generic maileon snackbar component*/}
            <MaileonSnackbar
                snackbar={snackbar}
                setSnackbar={setSnackbar}
                t={t}
            />

            <Dialog
                {...props}
                open={props.open}
                onClose={props.onClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >

                <DialogTitle id="alert-dialog-title">
                    {t('Create new mailing template')}
                </DialogTitle>

                <Alert severity={'info'}>
                    {t('Name must contain only letters, numbers and underscores. For example: order_confirmation, ReservationCancelled, etc.')}
                </Alert>

                <DialogContent>
                    <Stack gap={1} pt={1} width={400}>
                        <TextField
                            label={t('Name')}
                            size={'small'}
                            value={transactionType?.name || ''}
                            onChange={(e) => {
                                setTransactionType({
                                    ...transactionType,
                                    name: e.target.value
                                })
                            }}
                            fullWidth
                            required
                        />
                    </Stack>

                </DialogContent>

                <DialogActions>
                    <Button
                        id={'btn-close'}
                        onClick={() => {
                            props?.onClose()
                        }}
                    >
                        {t('Close')}
                    </Button>
                    <LoadingButton
                        variant={'contained'}
                        onClick={() => createTransactionTypeMut.mutate()}
                        loading={createTransactionTypeMut.isLoading}
                        disabled={!nameValid}
                    >
                        {t('Add')}
                    </LoadingButton>

                </DialogActions>

            </Dialog>
        </>
    )
}

export default QuickAddTransactionTypeDialog
